export default "__VITE_ASSET__Bu8ws9S4__"